import { BOPIS_TOOLTIP_GET_SUCCESS } from '../actionTypes/BOPISToolTipActionType';

const bopisToolTipReducer = function bopisToolTipReducer(state = '', action) {
    switch (action.type) {
        case BOPIS_TOOLTIP_GET_SUCCESS: {
            return action.bopisTooltipMessage;
        }
        default:
            return state;
    }
};

bopisToolTipReducer.reducerName = 'bopisTooltipMessage';
export default bopisToolTipReducer;
